import i18n from "i18next"
import { initReactI18next } from "react-i18next"
i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    // debug if environment is not production
    debug: process.env.NODE_ENV !== "production",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    defaultNS: "translations",
    resources: {},
  })
// }

export default i18n
